import { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import { getCasinoGameDetails, getMatchExposure } from "@/services/casinoApi";
import BetTableRace17 from "../components/race17/BetTableRace17";
import ResultRace17 from "../components/race17/ResultRace17";
import RightSection from "../components/RightSection/RightSection";
import styles from "./Race17.module.css";
import VideoBox from "../components/common/VideoBox";
import CasinoHeading from "../components/common/CasinoHeading";

// Helpers or static assets are handled via generic paths below.

function extractCasinoGame(url) {
  const match = url.match(/\/lord-games\/([^/?#]+)/);
  return match ? match[1] : null;
}

export default function Race17() {
  const [gameData, setGameData] = useState({});
  const [activeTab, setActiveTab] = useState("game");
  const [iframeSrc, setIframeSrc] = useState("");
  const { pathname } = useLocation();
  const [filteredPlayers, setFilteredPlayers] = useState([]);
  const [playersData, setPlayersData] = useState([]);
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);

  useEffect(() => {
    const name = extractCasinoGame(pathname) || "race17";
    setIframeSrc(`https://casino-stream.softgamingapi.com/casino-tv?id=${name}`);

    const fetchGameData = async () => {
      try {
        const response = await getCasinoGameDetails(name);
        setGameData(response);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, [pathname]);

  useEffect(() => {
    // Ported from frontend logic
    const subData = gameData?.data?.data?.sub || gameData?.data?.sub || gameData?.sub || [];
    const activeSubData = subData.filter(item => item.visible === 1);

    // Map to simple structure if needed by BetTable
    const players = activeSubData.map((item, idx) => ({
      player: item.nat || `Option ${idx + 1}`,
      back: item.b,
      lay: item.l,
      backStake: item.bs,
      layStake: item.ls,
    }));

    setFilteredPlayers(players);
    setPlayersData(activeSubData);
  }, [gameData]);

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id;
      const matchId = gameData?.data?.data?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            exposureMap[item.team_name] = parseFloat(item.exposure_amount) || 0;
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [gameData?.data?.data?.mid]);

  useEffect(() => {
    const matchId = gameData?.data?.data?.mid?.toString();
    if (!matchId) return;

    const timeoutId = setTimeout(() => {
      fetchExposure();
    }, 2000);

    const intervalId = setInterval(() => {
      fetchExposure();
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [gameData?.data?.data?.mid, fetchExposure]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleBetClick = (value, playerName, type, betData) => {
    console.log("Bet clicked:", { value, playerName, type, betData });
  };

  // Static cards for Race17
  const card1 = "/assets/img/card/10.jpg";
  const card2 = "/assets/img/card/11.jpg";
  const card3 = "/assets/img/card/12.jpg";
  const cardPattiBack = "/assets/img/card/patti_back.jpg";

  const playerA = {
    cards: [card1, card2, card3],
  };

  const playerB = {
    cards: [cardPattiBack, cardPattiBack, cardPattiBack],
  };

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.sectionA}>
          <CasinoHeading
            name="RACE 17"
            roundId={gameData?.data?.data?.mid || "157250124095658"}
            placedBetCount={myBets.length}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />

          {activeTab === "game" && (
            <>
              <VideoBox
                gameType="race17"
                resultData={gameData?.data?.data?.card}
                iframeSrc={iframeSrc}
                timerValue={gameData?.data?.data?.lt}
                playerA={playerA}
                playerB={playerB}
              />

              <div className={styles.tableContainer}>
                <div style={{ width: "100%" }}>
                  <BetTableRace17
                    data={filteredPlayers}
                    playersData={playersData}
                    onBetClick={handleBetClick}
                    exposures={exposures}
                    myBets={myBets}
                  />
                </div>
              </div>
              <div className={styles.heading}>
                <div>Last Result</div>
                <Link to="/admin/reports/casinoresult/race17">
                  <div className={styles.viewAll}>View All</div>
                </Link>
              </div>
              <ResultRace17
                data={gameData?.lrs || []}
                gameData={gameData}
              />
            </>
          )}


        </div>

        <RightSection
          sectionKey="race17"
          data={myBets}
          title="Matched"
          viewMoreText="View More"
          onViewMore={() => {
            // Handle view more action
            console.log("View more clicked for race17");
          }}
        />
      </div>
    </Layout>
  );
}
